<form [formGroup]="printForm" soho-busyindicator class="csv-action-form"  [ngClass]="{'form-layout-compact': useCompactFormLayout}">
  @if (useTabs) {
    @if (true) {
      <div>
        <div  class="csv-tab-row">
          <div class="csv-criteria field">
            <label for="name">{{'Name' | translate}}</label>
            <input formControlName="name" type="text" id="name" data-automation-id="lm-export-to-csv-name" maxlength="40" soho-trackdirty/>
          </div>
          <div class="csv-criteria field only-alert">
            <label for="recordLimitAlert"></label>
            <span id="recordLimitAlert" soho-alert data-automation-id="lm-export-to-csv-record-limit-alert"></span>
          </div>
        </div>
      </div>
    }
    <div soho-tabs>
      <div soho-tab-list-container>
        <ul soho-tab-list>
          <li soho-tab [hidden]="false">
            <a soho-tab-title tabId="tabs-csv-display" data-automation-id="lm-export-to-csv-display-tab">{{'PDFDisplayTab' | translate}}</a>
          </li>
          <li soho-tab  [hidden]="!printInfo.includeRecordLimit && !printInfo.isTreeList">
            <a soho-tab-title tabId="tabs-csv-content" data-automation-id="lm-export-to-csv-content-tab">{{'PDFContentTab' | translate}}</a>
          </li>
          <li soho-tab [hidden]="!isUseAllActorGroups">
            <a soho-tab-title tabId="tabs-csv-sharing" data-automation-id="lm-export-to-csv-sharing-tab">{{'PDFSharingTab' | translate}}</a>
          </li>
          <li soho-tab [hidden]="!showAdvancedTab">
            <a soho-tab-title tabId="tabs-csv-advanced" data-automation-id="lm-export-to-csv-advanced-tab">{{'PDFAdvancedTab' | translate}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div soho-tab-panel tabId="tabs-csv-display">
      @if (true) {
        <div class="csv-tab-content">
          <div class="csv-tab-row">
            <div class="csv-criteria field">
              <label for="csvFormat">{{'CSVFormat' | translate}}</label>
              <select formControlName="csvFormat" soho-dropdown id="csvFormat" data-automation-id="lm-export-to-csv-format" [attributes]="csvFormatDropdownAttributes" noSearch soho-trackdirty class="dropdown-sm">
                @for (option of formatOptions; track option) {
                  <option [value]="option.value">{{option.label}}</option>
                }
              </select>
            </div>
          </div>
          <div class="csv-tab-row">
            <div class="csv-criteria field">
              <label for="columnHeaderType">{{'Headers' | translate}}</label>
              <select formControlName="columnHeaderType" soho-dropdown id="columnHeaderType" data-automation-id="lm-export-to-csv-header-style"  [attributes]="headerStyleDropdownAttributes" noSearch soho-trackdirty class="dropdown-sm">
                @for (option of columnHeaderOptions; track option) {
                  <option [value]="option.value">{{option.label | translate}}</option>
                }
              </select>
            </div>
          </div>
          @if (printForm.get('columnHeaderType').value === '1') {
            <div class="csv-tab-row">
              <label class="csv-criteria info-message">{{'HeadersNote' | translate}}</label>
            </div>
          }
          <div class="csv-tab-row">
            <div class="csv-criteria field">
              <label soho-label for="lm-export-to-csv-retention-duration-option">{{'RetentionDuration' | translate}}</label>
              <select formControlName="retentionDurationOption" soho-dropdown id="lm-export-to-csv-retention-duration-option" data-automation-id="lm-export-to-csv-retention-duration-option"  [attributes]="retentionDurationDropdownAttributes" noSearch soho-trackdirty class="dropdown-md">
                <option [value]="'default'">{{'RetentionDurationOptionDefault' | translate}}</option>
                <option [value]="'one-week'">{{'RetentionDurationOptionWeek' | translate}}</option>
                <option [value]="'one-month'">{{'RetentionDurationOptionMonth' | translate}}</option>
                <option [value]="'one-year'">{{'RetentionDurationOptionYear' | translate}}</option>
                <option [value]="'five-years'">{{'RetentionDurationOptionFiveYear' | translate}}</option>
                <option [value]="'custom'">{{'RetentionDurationOptionCustom' | translate}}</option>
              </select>
            </div>
            @if (showRetentionDuration) {
              <div class="field csv-criteria lm-no-label" >
                <label soho-label for="lm-export-to-csv-retention-duration"></label>
                <!-- soho-spin box doesn't have an attributes input. So instead attributes is
                being placed on the data-options attribute. That will then get picked up by
                spinbox.js in ids-enterprise.
                -->
                <input formControlName="retentionDuration" soho-spinbox
                  id="lm-export-to-csv-retention-duration"
                  attr.data-options="{{retentionDurationOptions}}"
                  soho-trackdirty
                  class="input-sm"
                  />
                </div>
              }
            </div>
          </div>
        }
      </div>
      <div soho-tab-panel tabId="tabs-csv-content">
        @if (true) {
          <div class="csv-tab-content">
            @if (printInfo.includeRecordLimit) {
              <div class="csv-tab-row">
                <div class="csv-criteria field">
                  <label soho-label for="recordLimitOption">{{'PDFCSVRecordLimit' | translate}}</label>
                  <select formControlName="recordLimitOption" soho-dropdown id="recordLimitOption" data-automation-id="lm-export-to-csv-record-limit-option"  [attributes]="recordLimitDropdownAttributes" noSearch soho-trackdirty class="dropdown-md">
                    <option [value]="'default'">{{'PDFDefaultRecordsOption' | translate}}</option>
                    <option [value]="'all'">{{'PDFAllRecordsOption' | translate}}</option>
                    <option [value]="'large'">{{'PDFLargeRecordsOption' | translate}}</option>
                    <option [value]="'small'">{{'PDFSmallRecordsOption' | translate}}</option>
                    <option [value]="'custom'">{{'PDFCustomRecordsOption' | translate}}</option>
                  </select>
                </div>
                @if (showMaxRows) {
                  <div class="csv-criteria field">
                    <label soho-label for="maxRows"></label>
                    <input formControlName="maxRows" #maxRows soho-spinbox
                      [max]="excelRowLimit"
                      soho-trackdirty id="maxRows"
                      attr.data-options="{{maxRowsDataOptions}}"
                      class="input-sm"
                      />
                    </div>
                  }
                </div>
              }
              @if ((includeExportOption || detailList.length > 0)) {
                <div  class="csv-tab-row">
                  <div class="csv-criteria field">
                    <label soho-label for="exportOption">{{'ExportOptions' | translate}}</label>
                    <select formControlName="exportOption" soho-dropdown id="exportOption" data-automation-id="lm-export-to-csv-print-option" [attributes]="printOptionDropdownAttributes" noSearch soho-trackdirty class="dropdown-md" (change)="getDetailOptions()">
                      @for (option of exportOptions; track option) {
                        <option [value]="option.value">{{option.label}}</option>
                      }
                    </select>
                  </div>
                  @if (printInfo.isTreeList && showMaxLevels) {
                    <div class="csv-criteria field">
                      <label soho-label for="maxLevels"></label>
                      <input formControlName="maxLevels"
                        #maxLevels
                        soho-spinbox
                        min="1"
                        max="99"
                        soho-trackdirty
                        id="maxLevels"
                        attr.data-options="{{maxLevelsDataOptions}}"
                        class="input-sm"
                        />
                      </div>
                    }
                    @if (showDetailList) {
                      <div class="csv-criteria field">
                        <label soho-label for="detailList"></label>
                        <select formControlName="detailList" soho-dropdown id="detailList" data-automation-id="lm-export-to-csv-detail-list" [attributes]="detailListDropdownAttributes" attributes="" noSearch soho-trackdirty class="dropdown-mm">
                          @for (option of detailList; track option) {
                            <option [value]="option.name">{{option.title}}</option>
                          }
                        </select>
                      </div>
                    }
                  </div>
                }
                @if (showSelectedRecord) {
                  <div class="csv-criteria field top-margin">
                    <input formControlName="selectedRecordOnly" soho-checkbox type="checkbox" id="selectedRecordOnly" data-automation-id="lm-export-to-csv-selected-record-only" />
                    <label for="selectedRecordOnly" class="checkbox-label">{{'CSVSelectedWithDetails' | translate}}</label>
                  </div>
                }
                @if (includeDetailOption) {
                  <div  class="csv-tab-row">
                    <div class="csv-criteria field">
                      <label soho-label for="detailOption">{{'DetailsOptions' | translate}}</label>
                      <select formControlName="detailOption" soho-dropdown id="detailOption" data-automation-id="lm-export-to-csv-detail-option" [attributes]="detailOptionsDropdownAttributes" noSearch soho-trackdirty class="dropdown-md">
                        @for (option of detailsOptions; track option) {
                          <option [value]="option.value">{{option.label}}</option>
                        }
                      </select>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <div soho-tab-panel tabId="tabs-csv-sharing">
            @if (true) {
              <div class="csv-tab-content">
                <div  class="csv-tab-row">
                  <div class="field csv-criteria">
                    <lm-lookup-basic #reportDistributionGroup data-automation-id="lm-export-to-csv-distribution-group-field"
                      [fieldLabel]="reportDistGroupLabel"
                      [sourceField]="sourceFieldName"
                      (lookupValueChangedEvent) = "reportDistributionGroupChanged($event)">
                    </lm-lookup-basic>
                  </div>
                  <div class="field csv-criteria" [hidden]="!showDynamicActors">
                    <label soho-label for="dynamicActors"
                    [required]="atLeastOneDynamicActor">{{dynamicActorsLabel}}</label>
                    <lm-list-dropdown #dynamicActorsComponent id="dynamicActors" data-automation-id="lm-export-to-csv-dynamic-actors"
                    [options]="dynamicActorOptions" soho-alert></lm-list-dropdown>
                  </div>
                </div>
                <div class="csv-tab-row">
                  @if (showEmptyReportOptions) {
                    <div class="csv-criteria field">
                      <label soho-label for="emptyReportOptions">{{'EmptyReportOptions' | translate}}</label>
                      <select formControlName="emptyReportOptions" soho-dropdown id="emptyReportOptions" data-automation-id="lm-print-to-csv-empty-report-option"  [attributes]="emptyReportOptionDropdownAttributes" noSearch soho-trackdirty class="dropdown-md">
                        <option [value]="'default'">{{'SendWithNotification' | translate}}</option>
                        <option [value]="'suppressWithoutNotification'">{{'SuppressWithoutNotification' | translate}}</option>
                        <option [value]="'suppressWithNotification'">{{'SuppressWithNotification' | translate}}</option>
                      </select>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
          <div soho-tab-panel tabId="tabs-csv-advanced">
            @if (true) {
              <div class="csv-tab-content">
                <div class="csv-tab-row">
                  <div class="csv-criteria field">
                    <input formControlName="needsMultiThreading" soho-checkbox type="checkbox" id="needMultiThreads" data-automation-id="lm-export-to-csv-need-multi-threads" />
                    <label for="needMultiThreads" class="checkbox-label">{{'NeedsMultiThreading' | translate}}</label>
                  </div>
                </div>
                @if (showMultiThreadInputs) {
                  <div class="csv-tab-row" >
                    <div class="csv-criteria field">
                      <label soho-label for="numberOfThreads">{{'CSVNoOfThreads' | translate}}</label>
                      <input formControlName="numberOfThreads"
                        #noOfThreads
                        soho-spinbox
                        min="2"
                        step="1"
                        max="10"
                        soho-trackdirty
                        id="numberOfThreads"
                        attr.data-options="{{numberOfThreadsDataOptions}}"
                        class="input-sm"
                        />
                      </div>
                      <div class="field csv-criteria">
                        <label for="multiThreadFieldName">{{'CSVMultiThreadField' | translate}}</label>
                        <select formControlName="multiThreadFieldName" soho-dropdown id="multiThreadFieldName" data-automation-id="lm-export-to-csv-multi-thread-field-name"  [attributes]="multiThreadFieldNameDropdownAttributes" soho-trackdirty class="dropdown-md">
                          @for (option of multiThreadFieldNameOptions; track option) {
                            <option [value]="option">{{option}}</option>
                          }
                        </select>
                      </div>
                    </div>
                    <div class="csv-tab-row">
                      <div class="csv-criteria field alert-fit-content">
                        <span id="multiThreadAlert" soho-alert data-automation-id="lm-export-to-csv-multi-thread-alert">{{'MultiThreadAlert' | translate}}</span>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          } @else {
            @if (true) {
              <div>
                <div  class="csv-tab-row">
                  <div class="csv-criteria field">
                    <label for="name">{{'Name' | translate}}</label>
                    <input formControlName="name" type="text" id="name" data-automation-id="lm-export-to-csv-name" maxlength="40" soho-trackdirty/>
                  </div>
                  <div class="csv-criteria field only-alert">
                    <label for="recordLimitAlert"></label>
                    <span id="recordLimitAlert" soho-alert data-automation-id="lm-export-to-csv-record-limit-alert"></span>
                  </div>
                </div>
              </div>
            }
            @if (true) {
              <div class="csv-tab-content">
                <div class="csv-tab-row">
                  <div class="csv-criteria field">
                    <label for="csvFormat">{{'CSVFormat' | translate}}</label>
                    <select formControlName="csvFormat" soho-dropdown id="csvFormat" data-automation-id="lm-export-to-csv-format" [attributes]="csvFormatDropdownAttributes" noSearch soho-trackdirty class="dropdown-sm">
                      @for (option of formatOptions; track option) {
                        <option [value]="option.value">{{option.label}}</option>
                      }
                    </select>
                  </div>
                </div>
                <div class="csv-tab-row">
                  <div class="csv-criteria field">
                    <label for="columnHeaderType">{{'Headers' | translate}}</label>
                    <select formControlName="columnHeaderType" soho-dropdown id="columnHeaderType" data-automation-id="lm-export-to-csv-header-style"  [attributes]="headerStyleDropdownAttributes" noSearch soho-trackdirty class="dropdown-sm">
                      @for (option of columnHeaderOptions; track option) {
                        <option [value]="option.value">{{option.label | translate}}</option>
                      }
                    </select>
                  </div>
                </div>
                @if (printForm.get('columnHeaderType').value === '1') {
                  <div class="csv-tab-row">
                    <label class="csv-criteria info-message">{{'HeadersNote' | translate}}</label>
                  </div>
                }
                <div class="csv-tab-row">
                  <div class="csv-criteria field">
                    <label soho-label for="lm-export-to-csv-retention-duration-option">{{'RetentionDuration' | translate}}</label>
                    <select formControlName="retentionDurationOption" soho-dropdown id="lm-export-to-csv-retention-duration-option" data-automation-id="lm-export-to-csv-retention-duration-option"  [attributes]="retentionDurationDropdownAttributes" noSearch soho-trackdirty class="dropdown-md">
                      <option [value]="'default'">{{'RetentionDurationOptionDefault' | translate}}</option>
                      <option [value]="'one-week'">{{'RetentionDurationOptionWeek' | translate}}</option>
                      <option [value]="'one-month'">{{'RetentionDurationOptionMonth' | translate}}</option>
                      <option [value]="'one-year'">{{'RetentionDurationOptionYear' | translate}}</option>
                      <option [value]="'five-years'">{{'RetentionDurationOptionFiveYear' | translate}}</option>
                      <option [value]="'custom'">{{'RetentionDurationOptionCustom' | translate}}</option>
                    </select>
                  </div>
                  @if (showRetentionDuration) {
                    <div class="field csv-criteria lm-no-label" >
                      <label soho-label for="lm-export-to-csv-retention-duration"></label>
                      <!-- soho-spin box doesn't have an attributes input. So instead attributes is
                      being placed on the data-options attribute. That will then get picked up by
                      spinbox.js in ids-enterprise.
                      -->
                      <input formControlName="retentionDuration" soho-spinbox
                        id="lm-export-to-csv-retention-duration"
                        attr.data-options="{{retentionDurationOptions}}"
                        soho-trackdirty
                        class="input-sm"
                        />
                      </div>
                    }
                  </div>
                </div>
              }
            }
            <!--TAB_CONTENT-->
            <!--NON_TAB_CONTENT-->

            <!--CONTEXT_FORM-->
            <!--DISPLAY_OPTIONS-->
            <!--SHARING_OPTIONS-->
            <!--CONTENT_OPTIONS-->
            <!-- ADVANCED_OPTIONS-->
          </form>
          <div #modalPlaceholder></div>
